const DotButton = props => {
  const {
    children,
    ...restProps
  } = props;
  return <button type="button" {...restProps} data-sentry-component="DotButton" data-sentry-source-file="DotButton.jsx">
      {children}
    </button>;
};
export default DotButton;